module.exports = __webpack_public_path__ + "static/office-bkg-760557d448b4cf67cab22356ed95bca1.png";